import { render, staticRenderFns } from "./DetalleBankAccount.vue?vue&type=template&id=74a51d52"
import script from "./DetalleBankAccount.vue?vue&type=script&lang=js"
export * from "./DetalleBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports